/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Close_ButtonInputs */

const en_chat_close_button = /** @type {(inputs: Chat_Close_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const fr_chat_close_button = /** @type {(inputs: Chat_Close_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer`)
};

const ms_sg2_chat_close_button = /** @type {(inputs: Chat_Close_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutup`)
};

/**
* | output |
* | --- |
* | "Close" |
*
* @param {Chat_Close_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const chat_close_button = /** @type {((inputs?: Chat_Close_ButtonInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Close_ButtonInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_close_button(inputs)
	if (locale === "fr") return fr_chat_close_button(inputs)
	return ms_sg2_chat_close_button(inputs)
});